import sanitizeHtml from 'sanitize-html';

// DisplayUserHtml's policy: the library's default plus one TEXT filter, so non-breaking spaces
// read as ordinary spaces. Keep it a text filter (it is never shown an attribute) and never
// edit the string after sanitising: the scheme check strips U+0000-0020 from an href but not
// U+00A0, so a leading NBSP is kept as a relative URL, and replacing it with a space
// afterwards leaves a live `javascript:` URL.
export const USER_HTML_SANITIZE_OPTIONS = {
  textFilter: (text) => text.replaceAll(String.fromCharCode(160), ' ')
};

// Never edit the string this returns.
export function sanitizeUserHtml(html) {
  return sanitizeHtml(html, USER_HTML_SANITIZE_OPTIONS);
}
